/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 *
 * Google CDN, Latest jQuery
 * To use the default WordPress version of jQuery, go to lib/config.php and
 * remove or comment out: add_theme_support('jquery-cdn');
 * ======================================================================== */

// TODO NOTE: Affix Product Catalogue 'product-list' to page as it scrolls

(function ($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function () {
        // JavaScript to be fired on all pages
        //MAIN SLIDER AND IT'S NAN
        //Nav slider
        $('#mainslider-nav').flexslider({
          animation: "slide",
          controlNav: false,
          animationLoop: true,
          slideshow: false,
          itemWidth: 210,
          itemMargin: 8,
          asNavFor: '#mainslides'
        });
        //Main slider
        $('#mainslides').flexslider({
          animation: "fade",
          controlNav: false,
          animationLoop: true,
          slideshow: true,
          sync: "#mainslider-nav"
        });

        //SLIDERS
        $('.offerslides').flexslider({
          animation: "fade",
          slideshowSpeed: 2500,
          direction: 'vertical',
          controlNav: true,
          directionNav: true
        });

        //SLIDERS
        $('.new_slides').flexslider({
          animation: "fade",
          slideshowSpeed: 2700,
          direction: 'vertical',
          controlNav: true,
          directionNav: true,
        });

        //Reset pop up window after close
        $('body').on('hidden.bs.modal', '.modal', function () {
          $(this).removeData('bs.modal');
          $('#video-frame').attr('src', '');
        });

        //FEEDS SAME HEIGHT COLS
        $(function () {
          var highest = 0,
            columns = $('.single-feed');
          columns.each(function () {
            var currColumnHeight = $(this).outerHeight();
            if (currColumnHeight > highest) {
              highest = currColumnHeight;
            }
          });
          columns.css('height', highest);
        });

        //Contact form Placeholders
        $('#contact-form .contact-name').prop('placeholder', 'Name');
        $('#contact-form .contact-number').prop('placeholder', 'Contact Number');
        $('#contact-form .contact-email').prop('placeholder', 'Email Address');
        $('#contact-form .contact-message').prop('placeholder', 'Message . . .');
        //Request catalogue and demos
        $('#form .request-phone').prop('placeholder', 'Full phone number with area code');
        $('#form .request-postcode').prop('placeholder', 'Space postcode correctly, e.g. DD2 3QD');

        //MODAL LOADING EXTARNAL LINK WORKAROUND [CALCULATOR TOOL]
        $('a.external').on('click', function (e) {
          e.preventDefault();
          var url = $(this).attr('href');
          $("#iframe-modal .modal-content .modal-body").html('<iframe width="100%" height="550px" frameborder="0" scrolling="yes" allowtransparency="true" src="' + url + '"></iframe>');
        });

        $('a.video-play').on('click', function (e) {
          e.preventDefault();
          var code = $(this).attr('href');
          $("#video-modal .modal-content .modal-body").html('<iframe id="video-frame" src="https://www.youtube.com/embed/' + code + '?controls=3&amp;theme=light&amp;modestbranding=1&amp;color=white&amp;autohide=1&amp;list=search&amp;showinfo=0&amp;rel=0" frameborder="0" allowfullscreen=""></iframe>');
        });

        //STICKY SIDEBAR
        $('.sidebar').theiaStickySidebar({
          // Settings
          additionalMarginTop: 50,
          updateSidebarHeight: true
        });

        //Header animation
        var animationStart = 120,
          animate = $('#masthead');
        content = $('.wrap');
        $(window).bind('scroll', function () {
          var offset = $(document).scrollTop();
          animate.addClass('header-small');
          if (offset <= animationStart) {
            animate.removeClass('header-small');
            content.css('padding-top', '0px');
          } else {
            animate.addClass('header-small');
            content.css('padding-top', '50px');
          }
        });

        // -- PRODUCT CATALOGUE SCRIPTS -- //
        var $ScrollingDiv = $('div.product-detail');

        function PositionScroller() {
          if (($ScrollingDiv.height() + 150) > $(window).height()) {
            $ScrollingDiv.css({ "marginTop": "0px" });
            $ScrollingDiv.removeClass('scrollingdiv');
            return;
          }
          if ($(window).scrollTop() > 150) {
            $ScrollingDiv.css({ "marginTop": ($(window).scrollTop() - 150) + "px" });
            $ScrollingDiv.addClass('scrollingdiv');
          } else {
            $ScrollingDiv.css({ "marginTop": "0px" });
            $ScrollingDiv.removeClass('scrollingdiv');
          }
        }

        // - Side categories /*
        $('div.product-menu ul > li > label.expandable-nocall').click(function () {
          if (!$(this).hasClass('open')) {
            $(this).parent().find('label').removeClass('selected');
          }
          $(this).next('ul').toggle('fast');
          $(this).toggleClass('open');
          new PositionScroller();
          return false;
        });

        // - Side categories
        $('div.product-menu ul > li > label.expandable').click(function () {
          if (!$(this).hasClass('open')) {
            $(this).parent().find('label').removeClass('selected');
            var data = {
              'action': 'display_category',
              'category_id': $(this).data('category')
            };
            $.post(ajaxurl, data, function (response) {
              var result = response.substring(1, response.length - 1);
              $('div.product-detail').html(result);
            });
          } else {
            $('div.product-detail').html('');
          }
          $(this).next('ul').toggle('fast');
          $(this).toggleClass('open');
          new PositionScroller();
          return false;
        });

        // - Side categories
        $('div.product-menu ul > li > label.callback').click(function () {
          var href = $(this).attr('href');
          $('div.product-menu ul > li > label.callback').removeClass('selected');
          $(this).addClass('selected');
          $('div.product-detail').html('<div class=\"working\"></div>');
          var data = {
            'action': 'display_materials',
            'category_id': $(this).data('category')
          };
          $.post(ajaxurl, data, function (response) {
            var obj = jQuery.parseJSON(response);
            $('div.product-detail').html(obj);
          });
          new PositionScroller();
          return false;
        });

        // - For dynamically created product lists
        $('body').on('click', 'div.product-list label', function () {
          $('div.product-menu ul > li > label.callback').removeClass('selected');
          $('div.product-detail').html('<div class="working"></div>');
          var data = {
            'action': 'display_materials',
            'category_id': $(this).data('category')
          };
          $.post(ajaxurl, data, function (response) {
            var obj = jQuery.parseJSON(response);
            $('div.product-detail').html(obj);
          });
          $('div.product-menu label[for=\"' + $(this).attr('for') + '\"]').addClass('selected');
          new PositionScroller();
          return false;
        });


        $(window).scroll(function () { new PositionScroller(); });
        // --- END PRODUCT CATALOGUE --- //
        //AUTO EXPAND ON URL #http://localhost:3000/about/#wrights-dental-[ID OF PANEL]
        var url = document.location.toString();
        if (url.match('#')) {
          $('.collapse').removeClass('in');
          $('#' + url.split('#')[1]).addClass('in');
        }

      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired


        //Read more on products
        $('p#read-more-intro a').on('click', function () {
          $('.introduction').css('height', 'auto');
          $('.introduction').toggleClass('active');
          $('p#read-more-intro').toggleClass('active');

          if ($('p#read-more-intro').hasClass("active")) {
            $('p#read-more-intro a').html('<span class="btn-label"><i class="fa fa-chevron-down"></i></span> Read less');
          } else {
            $('.introduction').css('height', '300px');
            $('p#read-more-intro a').html('<span class="btn-label"><i class="fa fa-chevron-down"></i></span> Read more');
          }

        });



      }
    },
    // Home page
    'home': {
      init: function () {
        // JavaScript to be fired on the home page
      },
      finalize: function () {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about': {
      init: function () {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
